import Request from "@/request.js";

export function getCourseTypeAndTheme() {
  return Request({
    url: "/base-data/course/getCourseTypeAndTheme",
    method: "get",
  });
}

export function getCourseDetail(courseId) {
  return Request({
    url: "/base-data/course-shop/getCourseDetail/" + courseId,
    method: "get",
  });
}

export function getCourseAuthorInfo(courseId) {
  return Request({
    url: "/base-data/course-shop/getCourseAuthorInfo/" + courseId,
    method: "get",
  });
}

export function buy(params) {
  return Request({
    url: "/student/student-shop/buy",
    data: params,
    method: "post",
  });
}

export function getCourseList(params) {
  return Request({
    url:
      "/base-data/course-shop/getCourseShopList?pageNum=" +
      params.pageNum +
      "&pageSize=" +
      params.pageSize,
    method: "post",
    data: params,
  });
}

export function getOrderStatus(orderNo) {
  return Request({
    url: "/business/order/getOrderStatus/" + orderNo,
    method: "get",
  });
}

export function saveConcat(params) {
  return Request({
    url: "/business/concat",
    method: "post",
    data: params,
  });
}

export function saveEvaluate(params) {
  return Request({
    url: "/base-data/course-evaluate",
    method: "post",
    data: params,
  });
}
